import { useMemo } from 'react';
import { useWallet } from '@solana/wallet-adapter-react';
import type { SolanaMessageSigner } from '../services/wallet/solana.ts';

function bytesToHex(bytes: Uint8Array): string {
  return Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
}

export function useSolanaSigner(): SolanaMessageSigner | undefined {
  const { publicKey, signMessage } = useWallet();

  return useMemo(() => {
    if (!publicKey || !signMessage) return undefined;

    return {
      getAddress: async () => publicKey.toBase58(),
      signMessage: async (message: Uint8Array) => {
        const signature = await signMessage(message);
        return `0x${bytesToHex(signature)}`;
      },
    };
  }, [publicKey, signMessage]);
}
